var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"items":_vm.items,"headers":_vm.headers,"item-key":"_id","loading":_vm.loading,"serverItemsLength":_vm.totalCount,"options":_vm.options,"dense":"","height":"70vh","footerProps":{
    'items-per-page-options': [50, 100, 200],
  }},on:{"dblclick:row":_vm.dblClickRow,"update:options":_vm.updateOptionsHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }